export default class EventEmitter {
  constructor() {
    this._listeners = Object.create(null);
  }

  on(event, fn) {
    (this._listeners[event] || (this._listeners[event] = [])).push(fn);
  }

  off(event, fn) {
    const list = this._listeners[event];
    if (!list) return;
    if (fn) {
      this._listeners[event] = list.filter(f => f !== fn);
    } else {
      delete this._listeners[event];
    }
  }

  emit(event, ...args) {
    const list = this._listeners[event];
    if (!list) return;
    for (let i = 0; i < list.length; i++) {
      list[i](...args);
    }
  }

  once(event, fn) {
    const wrapper = (...args) => {
      this.off(event, wrapper);
      fn(...args);
    };
    this.on(event, wrapper);
  }
}
